const YardDocumentReducer = (state = {}, action) => {
    switch (action.type) {
      case "YARD_DOCS":
        return Object.assign({}, state, {
          yarddocnames: action.data,
        });
      case "YARDUPLOAD_DOCS":
        return Object.assign({}, state, {
          yarduploaddocs: action.data,
        });
        case "HIDE_YARDDEL":
          return Object.assign({}, state, {
            hideyard: action.data,
          });
          case "SAVE_YARDDOC":
          return Object.assign({}, state, {
            saveyard: action.data,
          });
        default:
      return state;
  }
};

export default YardDocumentReducer;